/**
 * Created by nemio on 10.12.2016.
 */

import moment from 'moment';
import ar from 'moment/locale/es';

moment.updateLocale('es_MX', {
  calendar: {
    lastDay: '[Ayer]',
    sameDay: '[Hoy]',
    nextDay: '[Mañana]',
    lastWeek: 'dddd [Anterior]',
    nextWeek: 'dddd [Siguiente]',
    sameElse: '[Temprano]'
  }
});

const es_MX = {
  yes: 'Si',
  no: 'No',
  no_thanks: 'No, gracias',
  loading: 'Descargando...',
  global_error: 'Lo sentimos, el sitio no está disponible por razones técnicas. Por favor, inténtelo más tarde',
  email: 'Email',
  password: 'Contraseña',
  close: 'Cerrar',
  favorites: 'Favoritos',
  search: 'Buscar',
  related: 'Relacionado',
  tv: 'TV Canales',
  movies: 'Peliculas',
  tvseries: 'TV Series',
  on_now: 'Guia de Programas',
  cartoons: 'Caricaturas',
  purchases: 'Compras',
  premiere: 'Estreno',
  my_services: {
    my_services: 'Mis servicios',
    my_rents: 'Mi contenido',
    my_subscriptions: 'Mis suscripciones',
    subscriptions: 'Suscripciones',
    rents: 'Renta'
  },
  page: {
    home: 'Inicio',
    epg: 'Guia de Programas',
    favorites: 'Favoritos',
    notifications: 'Notificaciones',
    records: 'Mis registros',
    purchases: 'Compras',
    related: 'Relacionado',
    search: 'Buscar',
    collection: 'Coleccion'
  },
  error: {
    invalid_credentials: 'El nombre de usuario o la contraseña son incorrectos',
    invalid_credentials_description: ' ',
    blocked_subscription: 'Estimado Usuario, su suscripción ha vencido. Agregue saldo a su cuenta personal. Gracias',
    'invalid credentials': 'La contraseña anterior es incorrecta',
    'passwords mismatch': 'Las contraseñas deben coincidir.',
    'username field empty': 'El campo de correo electrónico no debe estar vacío.',
    'already exist': 'Este correo electrónico ya existe. Por favor, elija otra dirección de correo electrónico o Iniciar sesión',
    'password field empty': 'El campo de contraseña no debe estar vacío.',
    'password too short': 'La contraseña debe tener al menos 6 caracteres. Puede contener letras mayuscula minuscula simbolos y numeros.',
    'invalid password reset code': 'Código de confirmación inválido',
    'invalid ack': 'Código de confirmación no válido',
    'invalid pin': 'PIN no válido'
  },
  registration: {
    texts: {
      button: 'Crear cuenta',
      title: 'Registrate ahora!',
      description: 'Si aún no se ha registrado, hágalo'
    }
  },
  login: {
    login: 'Email',
    login_example: 'nombre@dominio.com',
    lost_your_password: '¿Olvidaste tu contraseña?',
    logout: 'Cerrar sesión',
    log_in: 'Inicio de sesión'
  },
  forgot_password: {
    login: 'Correo',
    login_example: 'nombre@dominio.com',
    lost_your_password: '¿Olvidaste tu contraseña?',
    forgot_password: '¿Olvidaste tu contraseña?',
    send: "Send",
    recovery_password: "Recupera tu contraseña",
    empty_field: "Campo vacío",
    wrong_email: "Correo incorrecto",
    reset_password_success_message: "Recibirá un correo electrónico con un enlace para restablecer su contraseña.",
    reset_password_error_message: "Recibirá un correo electrónico con un enlace para restablecer su contraseña.",
  },
  profile: {
    movie: {
      bundle: 'Bundle',
      min: 'min',
      fav_add: 'Añadir a favoritos',
      fav_remove: 'Remover de favoritos',
      trailer: 'Trailer',
      youtube_trailer: 'Youtube Trailer',
      multiscreen: 'Continuar en otra pantalla',
      related: 'Relacionado',
      share: 'Compartir',
      select_screen: 'Seleccionar pantalla',
    },
    tvSeries: {
      bundle: 'Bundle',
      min: 'min',
      fav_add: 'Añadir a favoritos',
      fav_remove: 'Remover de favoritos',
      trailer: 'Trailer',
      multiscreen: 'Continuar en otra pantalla',
      related: 'Relacionado',
      share: 'Compartir',
      select_screen: 'Seleccionar pantalla',
      seasons: 'Estaciones',
      episodes: 'Episodios',
      season_short: 'S', //S01E12
      episode_short: 'E', //S01E12
    },
    channel: {
      calendar: {
        before: 'Antes de',
        previously: 'Previamente',
        now: 'Ahora',
        after: 'Siguiente',
        hereafter: 'Más tarde',
        yesterday: 'Ayer',
        yesterday_at: 'Ayer a las',
        today: 'Hoy',
        today_at: 'Hoy a las',
        tomorrow: 'Mañana',
        tomorrow_at: 'Mañana a las',
        last: 'Último'
      },
      epg: 'EPG',
      bundle: 'Bundle',
      min: 'min',
      fav_add: 'Agregar a favoritos',
      fav_remove: 'Quitar de favoritos',
      record_add: 'Añadir grabación',
      record_remove: 'Borrar grabación',
      schedule_remove: 'Cancelar grabación',
      multiscreen: 'Continuar en otra pantalla',
      share: 'Compartir',
      select_screen: 'Seleccionar pantalla'
    },
    subscription: {
      subscription: 'Suscripción',
      included: 'Incluido',
      expires: 'Vence',
      bought: 'Compró',
      owned: 'Propio',
      subscription_period_end: 'Próxima fecha de pago',
      subscription_period_start: 'Inicio de suscripción',
      subscription_states: {
        active: 'Activo',
        trialing: 'Prueba',
        unpaid: 'Pago en espera',
        '_': 'Desconocido'
      },
      cancel: 'Cancelar suscripción',
      canceled: 'Cancelado',
      first_payment: 'Primer pago',
      details: 'Detalles',
      status: 'Status',
      are_you_sure: '¿Está seguro?',
      cancel_desc: 'Desea cancelar su suscripción a',
      re_subscribe: 'Puede reactivar su suscripción sólo terminando el período actual.',
      yes: 'Si',
      no: 'No'
    },
    packages: {
      included: 'Incluido',
      expires: 'Vence',
      bought: 'Compró',
      owned: 'Propio'
    },
    epg_event: {
      remind_me: 'Recordarme',
      not_remind: 'No recordar',
      record_add: 'Añadir grabación',
      record_remove: 'Borrar grabación',
      schedule_remove: 'Cancelar grabación'
    },
    notification: {
      remind_me: 'Recordarme',
      not_remind: 'No recordar',
    },
    npvr: {
      record_add: 'Añadir grabación',
      record_remove: 'Borrar grabación',
      schedule_remove: 'Cancelar grabación'
    },
    ratings: {
      rating_delimiter: '/'
    },
    persons: {
      operator: 'Operador',
      assembly: 'Asamblea',
      actor: 'Actor',
      director: 'Director',
      scenario: 'Guión',
      composer: 'Compositor',
      presenter: 'Presentador',
      music_director: 'Director musical',
      playback_singers: 'Cantantes de Playback',
      _: 'otros'
    },
    offers: {
      type: {
        'free': 'Gratis',
        'transactional-own': 'Comprar',
        'transactional-rent': 'Rentar',
        'subscription': 'Suscribir',
        'transactional-own-bundle': 'Comprar en paquete',
        'transactional-rent-bundle': 'Rentar en paquete',
        'subscription-bundle': 'Suscripción por paquete',
        '_': 'Otro'
      },
      pay_as_you_go: 'Ofertas de compra',
      select_bundle: 'Seleccionar paquete',
      or: 'o',
      free_trial: 'Prueba Gratis',
      free_trial_description: 'Después del pago de suscripción, retiraran el dinero de la cuenta.',
      unit: {
        hour: 'Hora',
        day: 'Día',
        week: 'Semana',
        month: 'Mes',
        year: 'Año',
      }
    }
  },
  player: {
    no_signal: 'Sin señal',
    youtube_connection_error: 'Error de conexión con Youtube'
  },
  more_menu_items: 'Más',
  empty_section: 'La sección actual está vacía',
  empty_result: 'Sin resultados',
  epg: {
    no_data: 'Sin información',
    now: 'Ahora',
    today: 'Hoy'
  },
  npvr: {
    filters: {
      status: 'Ordenar por estado de grabación',
      date: 'Ordenar por fecha de grabación',
      alphabet: 'Ordenar por título de grabación',
      channel: 'Ordenar por canal de grabación'
    },
    status: {
      pending: 'Pendiente',
      scheduled: 'Programado',
      recording: 'Grabando',
      finished: 'Terminado',
      failed: 'Falla',
      cancelled: 'Cancelado por el usuario'
    },
    npvr: 'Uso',
    limit_desc: 'Después de alcanzar el límite, no podrá agregar nuevos programas para grabar',
    limit_desc_warning: 'Casi has alcanzado el límite de los programas grabados',
    limit_desc_reached: 'Antes de añadir grabaciones, elimine programas antiguos o ya vistos'
  },
  genres: 'Generos',
  messages: {
    pin: {
      title: 'Ingrese su código PIN',
      ok: 'OK',
      cancel: 'Cancelar'
    },
    notification: {
      title: 'Recordatorio',
      on_channel: 'En el canal',
      is_switch_show_right_now: 'Comienza en 5 minutos. ¿Iniciar ahora mismo?'
    },
    share_request: {
      title: 'Compartir',
      vod: 'video',
      live: 'canal',
      you_have_received: 'Has recivido',
      sharing_notification: 'Compartir notificación. ¿Quieres ver?'
    },
    bookmark: {
      title: '¿Continuar viendo?',
      continue_from: 'Continuar desde',
      start_over: 'Comenzar de nuevo'
    }
  },
  settings: {
    settings: 'Ajustes',
    tabs: {
      login: {
        title: 'Iniciar Sesión',
        email: 'Correo',
        password: 'Contraseña',
        sign_in: 'Registrarse',
        error: 'El nombre de usuario o la contraseña están mal.',
        success: '¡Bienvenido, querido cliente!'
      },
      registration: {
        title: 'Registro',
        email: 'Correo',
        password: 'Contraseña',
        password2: 'Confirmar contraseña',
        first_name: 'Nomre',
        last_name: 'Apellido',
        sign_up: 'Registrarse',
        success: "Gracias por su registro!",
        need_confirmation: "Se envió un mensaje a su correo electrónico. Haga clic en el enlace para confirmar su registro.",
      },
      registration_confirm: {
        success: "Gracias por registrarse. Su Usuario y contraseña podran usarse ​​en otros dispositivos donde este servicio está disponible."
      },
      language: {
        title: 'Idioma',
        select_language: 'Seleccionar Idioma:'
      },
      parental_control: {
        title: 'Control Parental',
        description: 'Contron Parental ensendido',
        on: 'Encendido',
        off: 'Apagado'
      },
      change_password: {
        title: 'Cambiar Contraseña',
        save: 'Guardar',
        old_password: 'Contraseña anterior',
        new_password: 'Por favor ingrese la nueva contraseña',
        new_password2: 'Confirmar contraseña',
        success: 'Contraseña actualizada exitosamente'
      },
      reset_password: {
        title: 'Restablecer la contraseña',
        save: 'Guardar',
        enter_new_password: 'Introduzca una nueva contraseña',
        ack: 'Código de confirmación',
        password: 'Nuevo Password',
        success: 'Contraseña actualizada exitosamente'
      },
    },
  },
  toast: {
    type: {
      record: 'Grabar',
      favorite: 'Favorito',
      notification: 'Notificación',
      purchase: 'Compra',
      service: 'Servicio',
      cookies: 'Cookies',
      adblock: 'Ad block'
    },
    operation: {
      record_add_success: 'La grabación programada tuvo éxito',
      record_add_fail: 'Error en la grabación programada',
      record_remove_success: 'e Cancelo la grabación con éxito',
      record_remove_fail: 'Cancelar la grabación fallida',
      favorite_add_success: 'Se agregó correctamente',
      favorite_add_fail: 'Error al agregar',
      favorite_remove_success: 'Se eliminó correctamente',
      favorite_remove_fail: 'No se pudo eliminar',
      notification_add_success: 'Se agregó correctamente',
      notification_add_fail: 'Error al agregar',
      notification_remove_success: 'Se eliminó correctamente',
      notification_remove_fail: 'No se pudo eliminar',
      purchase_add_success: 'La operación se completo con éxito',
      purchase_add_fail: 'Operación fallida',
      purchase_remove_success: 'La operación se completo con éxito',
      purchase_remove_fail: 'Operación fallida',
      service_unstable_connection: 'Conexión inestable al servidor',
      enable_cookies: 'Por favor, habilite las cookies. ',
      disable_adblock: 'AdBlock can affect the functionality of the site. ' +
      'Please add us to Whitelist in your Ad blocker.'
    }
  }
};

export default es_MX;



// WEBPACK FOOTER //
// ./src/locales/dics/es_MX.js